import React, { Component, useState, useEffect, } from "react";
import "../notebooks/notebook.min.css";
import page404 from "assets/img/404.png";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Collapse,
  Modal,
  ModalHeader,
  ModalBody,
  Input, Button, ButtonGroup,
  InputGroup,
  InputGroupAddon,
  FormGroup,
  ListGroup,
  ListGroupItem,
  DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown,
  Badge,

} from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import StorageService from '../../services/api/Storage';
import DRSService from '../../services/api/Drs';
import RunService from '../../services/api/Run';
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import axios from 'axios'
import { Scrollbars } from 'react-custom-scrollbars';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import ReactPaginate from 'react-paginate';
import { uuidv4, renderOutput } from 'components/Notebook/operations/notebook';
import MarkDown from 'components/Notebook/MarkDown'
import CodeHighlight from 'components/Notebook/CodeHighlight'
import { HotTable } from "@handsontable/react";
import { registerAllModules } from 'handsontable/registry';
import { HandsonTableKey } from '../../settings/shared/constants';
import CommonService from '../../services/api/Common'
import { findIcon, imageFileExtension, CSVToJSONs, arrayToCSV } from "settings/shared/commonMethod";
import { toast } from 'react-toastify';
import FileJobsService from '../../services/api/FileJobs';
import moment from 'moment';
import Versioning from 'components/Versioning/Versioning'
import TinyURL from "tinyurl";
import Prism from 'prismjs';
import "prismjs/themes/prism.css";
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-python.min.js';
import 'prismjs/components/prism-python';
import 'assets/css/bc.scss'
import { STORAGE_DEFAULT_MOUNT_PATH, STORAGE_EXTERNAL_MOUNT_PATH, VERSIONTIMEOUT, NO_OF_RECORDS } from '../../settings/shared/constants';
import { confirmAlert } from 'react-confirm-alert';
import { HyperFormula } from 'hyperformula';
import Pagination from "../../assets/js/Pagination";
import PdfViewer from 'components/PdfViewer/PdfViewer';
import * as XLSX from "xlsx";
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';

// register Handsontable's modules
registerAllModules();

const trimFolderName = folderName => {
  if (folderName !== undefined && folderName !== null) {
    folderName = folderName.slice(0, -1);
    return folderName.split('/').pop() 
   }
};
const trimFileName = fileName => {
  if (fileName !== undefined && fileName !== null) {
    return fileName.split('/').pop()
  }
};

const delimiteroptions = [
  { label: "Comma Seperated Value (,)", value: "," },
  { label: "Pipe Seperated Value (|)", value: "|" }
];
const AddStorageItems = props => {
  let items = [];

  const {
    isSideSplited,
    splitscreen,
    folders,
    files,
    loadmoreFlag,
    showFilesModal,
    nextPageToken,
    loadflagStorage,
    viewSelected,
    sourceStorageId,
    sourceRootFolder,
    configArray
  } = props;

  const [isShowContext, setShowContext] = useState(false)

  const [showRenameModal, setshowRenameModal] = useState(false)

  const [renameToBeCreate, setrenameToBeCreate] = useState("")

  const showContext = () => setShowContext(true)
  const hideContext = () => setShowContext(false)

  const [isGetExtract, setExtractAction] = useState(false)

  const showExtract = () => setExtractAction(true)
  const hideExtract = () => setExtractAction(false)

  const [contextMargin, setContextMargin] = useState(null)
  const setContextMenuMargin = (margin) => setContextMargin(margin)

  const [selectedFiles, setSelectedFiles] = useState([])
  const [selectedFolders, setSelectedFolders] = useState([])

  const [isFileAction, setFileAction] = useState(false)
  const enableDisableViewDownload = () => {
    if (selectedFolders.length === 0 && selectedFiles.length === 1) {
      setFileAction(true)
    } else {
      setFileAction(false)
    }
  }
  const [isAllFolders, setAllFolders] = useState(false)
  const showpopupFolders = () => setAllFolders(true)
  const onFolderClick = (event, folderName) => {
    let fname = folderName;
    const target = event.currentTarget
    if (target.dataset.id === folderName) {
      target.className = "py-2 storage-item folderitem row active";
    }
    event.stopPropagation()
    event.preventDefault()
    props.fetchStorageItems(fname, deselectAll)
    // props.previewFile(trimFolderName(fname), foldpath)
  }
  const openStorageView = (name, event) => {
    event.preventDefault()
    let newUrl;
    let currentUrl = window.location.href;
    newUrl = currentUrl.split("?path=");
    let reg = "/modelspace";
    let sName = sourceStorageId === null ? "" : sourceStorageId;
    let root = sourceRootFolder === null ? "" : sourceRootFolder;
    let redirectUrl = newUrl[0].replace(reg, "/storageView?storage=" + sName + "&root=" + root + "&file=" + name);
    window.open(redirectUrl, "_blank");
  }
  const downloadFile = (name, event) => {
    event.preventDefault()
    let sName = sourceStorageId === null ? "" : sourceStorageId;
    let root = sourceRootFolder === null ? "" : sourceRootFolder;
    localStorage.setItem("filePathStorage", name);
    let myPath = localStorage.getItem("filePathStorage");
    StorageService.downloadObjectUrl(myPath, sName, root)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.download_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }
  const copyAlert = () => {
    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied!</b></i>);
  }
  const toggleRenameModal = () => {
    if (showRenameModal) {
      setshowRenameModal(false)
    } else {
      setshowRenameModal(true)
    }
    hideContext()
    deselectAll()
  }
  const handleRenameChange = (event) => {
    setrenameToBeCreate(event.target.value);
  }
  const renameUpdate = (event) => {
    event.preventDefault();
    if (renameToBeCreate === "" || renameToBeCreate === undefined) {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please enter name</b></i>);
    } else {
      toggleRenameModal();
      props.renameFile(renameToBeCreate);
    }
  }
  const popPathName = (path) => {
    var replacedPath = path.replace(/\/$/, '');
    var rename = replacedPath.split('/').pop();
    return rename;
  }
  /*  rename file/folder  */
  const onRenameClick = (event, fileName, isDir) => {
    event.preventDefault()
    let name = fileName;
    props.selectMoveFile(name, "Move", isDir)
    let renamewats = popPathName(name)
    setrenameToBeCreate(renamewats);
    toggleRenameModal();
    hideContext()
    deselectAll()
  }
  const GetLink = (name, event) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let newUrl;
    let currentUrl = window.location.href;
    newUrl = currentUrl.split("?path=");
    let reg = "/modelspace";
    let sName = sourceStorageId === null ? "" : sourceStorageId;
    let root = sourceRootFolder === null ? "" : sourceRootFolder;
    let redirectUrl = newUrl[0].replace(reg, "/storageView?storage=" + sName + "&root=" + root + "&file=" + name);
    TinyURL.shorten(redirectUrl).then((res) => {
      var tempInput = document.createElement("input");
      tempInput.value = res;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      copyAlert()
    })
  }
  const GetExtract = (name, event) => {
    event.preventDefault()
    let isDirectory = !isFileAction
    let destifolder = props.currFolder;
    if (destifolder == null) {
      destifolder = "/"
    }
    let extractdata = {
      "destinationPath": destifolder,
      "paths": [
        {
          "isDir": isDirectory,
          "sourcePath": name

        }
      ],
      "sourcePath": [
        name
      ],
      "storageType": "GOOGLE"
    }
    FileJobsService.ExtractFile(extractdata)
      .then((response) => {
        props.fetchProgress(response.jobState, response.message)
        setTimeout(() => {
          props.fetchStorageItems(props.currFolder, null, isSideSplited)
        }, 3000);


      });
  }
  const onRowClick = (event, itemType, itemName) => {
    event.preventDefault()
    const target = event.currentTarget
    target.dataset.select = true
    if (itemType !== "folder") {
      props.previewFile(itemName, itemType, sourceStorageId, sourceRootFolder)
    }
  }
  const deselectAll = () => {
    let classNameOfSelectedItem;
    let classNameToBeAdd;
    if (viewSelected === 1) {
      classNameOfSelectedItem = 'storage-item-select'
      classNameToBeAdd = 'py-2 storage-item row folderitem'
    } else {
      classNameOfSelectedItem = 'card-item-select'
      classNameToBeAdd = 'card-item card'
    }
    const elems = [].slice.call(document.getElementsByClassName(classNameOfSelectedItem))
    for (const elem of elems) {
      elem.dataset.select = false
      elem.className = classNameToBeAdd
    }
    setSelectedFolders([])
    setSelectedFiles([])
  }
  const addItemToSelected = (itemType, itemName) => {
    if (itemType === 'file') {
      const _selectedFiles = selectedFiles
      if (_selectedFiles.indexOf(itemName) === -1) {
        _selectedFiles.push(itemName)
        setSelectedFiles(_selectedFiles)
      }
    } else if (itemType === 'folder') {
      const _selectedFolders = selectedFolders
      if (_selectedFolders.indexOf(itemName) === -1) {
        _selectedFolders.push(itemName)
        setSelectedFolders(_selectedFolders)
      }
    }
  }
  const [isShowMenu, setShowMenu] = useState(false)
  const [isShowMenuName, setShowMenuName] = useState()
  const showMenu = (itemName) => {
    setShowMenu(true)
    // setShowMenuName(itemName)
  }
  const hideMenu = () => setShowMenu(false)
  const handleMouseHover = (event, itemType, itemName) => {
    if (itemName !== "emptyfolder") {
      const target = event.currentTarget;
      if (target.dataset.id === itemName) {
        target.className = "py-2 storage-item folderitem row active";
        showMenu(itemName)
        setShowMenuName(itemName)
      }
      else {
        target.className = "py-2 storage-item folderitem row";
        hideMenu()
      }
      const getextnzip = trimFileName(itemName).substr(trimFileName(itemName).lastIndexOf('.') + 1);
      if ((getextnzip === "zip") || (getextnzip === "tar") || (getextnzip === "rar") || (getextnzip === "gz")) {
        showExtract()
      }
      else {
        hideExtract()
      }
    }
    event.preventDefault()
    setSelectedFiles([])
    setSelectedFolders([])
    addItemToSelected(itemType, itemName)
    enableDisableViewDownload()

  }
  const handleMouseLeave = (event) => {
    event.preventDefault()
    hideMenu()
  }
  /* View File   */
  const onViewClick = (event, fileName) => {
    event.preventDefault()
    openStorageView(fileName, event)
    hideContext()
    deselectAll()
  }
  /* Download File   */
  const onDownloadClick = (event, fileName) => {
    event.preventDefault()
    downloadFile(fileName, event)
    hideContext()
    deselectAll()

  }
  /* get Shareable link  */
  const onShareClick = (event, fileName) => {
    event.preventDefault()
    GetLink(fileName, event)
    hideContext()
    deselectAll()

  }
  /* Extract Folder */
  const onExtractClick = (event, fileName) => {
    event.preventDefault()
    GetExtract(fileName, event)
    hideContext()
    deselectAll()

  }
  /* Move file/folder  */
  const onMoveClick = (event, fileName, isDir) => {
    event.preventDefault()
    let name = fileName;
    let movewats = name
    let ShowFold = "true"
    showpopupFolders()
    props.toggleShowFiles(props.currFolder, ShowFold, movewats, "Move", isDir)
    hideContext()
    deselectAll()

  }
  /*  Paste file/folder  */
  const onPasteClick = (event, fileName) => {
    let name = fileName
    let isDirectory = !isFileAction
    let pastedetails = name
    props.pasteFolder(isSideSplited, pastedetails, isDirectory)
    hideContext()
    deselectAll()

  }
  /*  Copy file/folder  */
  const onCopyClick = (event, fileName, isDir) => {
    event.preventDefault()
    let name = fileName
    let copywats = name
    let ShowFold = "true"
    showpopupFolders()
    props.toggleShowFiles(props.currFolder, ShowFold, copywats, "Copy", isDir)
    props.selectCopyFile(copywats, "Copy", isDir)
    hideContext()
    deselectAll()

  }
  /* copy file path */
  const onCopyPathClick = (event, path) => {
    event.preventDefault()
    if (configArray !== undefined && configArray !== null && configArray.length > 0) {
      let filterArray = configArray.filter(item => item.id === sourceStorageId);
      let prefixPath = "";
      if (filterArray.length > 0) {
        let sName = filterArray[0].name;
        let platfromDefault = filterArray[0].platformDefault;
        if (platfromDefault) {
          prefixPath = STORAGE_DEFAULT_MOUNT_PATH;
        } else {
          prefixPath = STORAGE_EXTERNAL_MOUNT_PATH + sName + "/" + sourceRootFolder + "/";
        }
        if (path !== undefined) {
          var filepath = document.createElement('textarea')
          filepath.innerText = prefixPath + path
          document.body.appendChild(filepath)
          filepath.select()
          document.execCommand('copy')
          filepath.remove()
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied</b></i>);
        }
      }
    }
  }
  /*  Delete/Trash file/folder  */
  const onDeleteClick = (event, fileName, deleteevent) => {
    event.preventDefault()
    let name = fileName;
    let isDirectory = !isFileAction
    const title = isFileAction ? 'Delete File' : 'Delete Folder'
    const message = (
      isFileAction
        ? 'Are you sure to delete this file -' + trimFileName(name) + '?'
        : 'Are you sure to delete this folder -' + trimFolderName(name) + '?'
    )
    confirmAlert({
      title: title,
      message: message,
      buttons: [
        {
          label: 'Yes',
          onClick: e => {
            let destifolder = "";
            let sourcefolder = name;
            let movetotrashdata = {
              "destinationPath": destifolder,
              "paths": [
                {
                  "isDir": isDirectory,
                  "sourcePath": sourcefolder

                }
              ],
              "sourceStorage": {
                "rootFolder": sourceRootFolder,
                "storageId": sourceStorageId
              }
            }
            if (sourceStorageId === null) {
              delete movetotrashdata["sourceStorage"]
            }
            /*  Move to Trash */
            if (deleteevent === "Trash") {
              FileJobsService.TrashFolder(movetotrashdata)
                .then((response) => {
                  props.fetchProgress(response.jobState, response.message)
                  props.fetchStorageItems(props.currFolder, null)
                });
            }
            /*  Delete From Trash */
            if (deleteevent === "Delete") {
              let sourcefolder = name;
              let deletedata = {
                "destinationPath": destifolder,
                "paths": [
                  {
                    "isDir": isDirectory,
                    "sourcePath": sourcefolder

                  }
                ],
                "sourceStorage": {
                  "rootFolder": sourceRootFolder,
                  "storageId": sourceStorageId
                }
              }
              if (sourceStorageId === null) {
                delete deletedata["sourceStorage"]
              }
              FileJobsService.DeleteFolder(deletedata)
                .then((response) => {
                  props.fetchProgress(response.jobState, response.message)
                  props.fetchStorageItems(props.currFolder, null)
                });
            }
          }
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    })
    hideContext()
    deselectAll()

  }
  /* Restore file/folder  */
  const onRestoreClick = (event, fileName) => {
    event.preventDefault()
    let name = fileName
    let isDirectory = !isFileAction
    const title = isFileAction ? 'Restore File' : 'Restore Folder'
    const message = (
      isFileAction
        ? 'Are you sure to restore this file -' + trimFileName(name) + '?'
        : 'Are you sure to restore this folder -' + trimFolderName(name) + '?'
    )
    confirmAlert({
      title: title,
      message: message,
      buttons: [
        {
          label: 'Yes',
          onClick: e => {
            let destifolder = "";
            let sourcefolder = name;
            let restoredata = {
              "destinationPath": destifolder,
              "paths": [
                {
                  "isDir": isDirectory,
                  "sourcePath": sourcefolder

                }
              ],
              "sourceStorage": {
                "rootFolder": sourceRootFolder,
                "storageId": sourceStorageId
              }
            }
            if (sourceStorageId === null) {
              delete restoredata["sourceStorage"]
            }
            FileJobsService.RestoreFile(restoredata)
              .then((response) => {
                props.fetchProgress(response.jobState, response.message, isSideSplited)
                props.fetchStorageItems(props.currFolder, null, isSideSplited)

              })

          }
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    })
    hideContext()
    deselectAll()

  }
  const mouseDownEvent = (event) => {
    if (event.target.dataset.type !== 'context' && isShowContext) {
      hideContext()
      deselectAll()

    }
  }
  useEffect(() => {
    document.addEventListener("mousedown", mouseDownEvent)
    Prism.highlightAll();

    return () => {
      document.removeEventListener("mousedown", mouseDownEvent)
    }
  }, [isShowContext])
  for (const folder of folders) {
    const folderName = trimFolderName(folder)
    items.push(
      <div key={uuidv4()}>
        <Row
          tag="a"
          className="py-2 storage-item folderitem"
          data-id={folderName}
          onMouseEnter={e => { handleMouseHover(e, 'folder', folderName) }}
          onMouseLeave={handleMouseLeave}
          title={folderName}
        >
          <Col md="10" xs="10" onContextMenu={e => e.preventDefault()}>
            <div className="overflowStyle">
              <span
                className="folder"
                data-type="folder"
                data-id={folder}
                data-name={folder}
                onClick={e => { onRowClick(e, 'folder', folder); onFolderClick(e, folder); }}
              >
                <i className="fas fa-folder mr-3"></i>{folderName}
              </span>
            </div>
          </Col>
          {isShowMenuName === folderName &&
            <Col md="2" xs="2" className="storagetxt" id={folderName}>
              <div className="">
                <UncontrolledDropdown direction="down">
                  <DropdownToggle tag="span" className="pointerclass"
                    onClick={e => e.preventDefault()}>
                    <i className="fas fa-ellipsis-v font12" />
                  </DropdownToggle>
                  <DropdownMenu persist right className="dropdown-menu-arrow" flip={false} modifiers={{
                    flip: {
                      behavior: "flip",
                      enabled: true
                    }, preventOverflow: { boundariesElement: 'window' }
                  }}>
                    {props.itstrash && <div>
                      <DropdownItem href="" onClick={e => { onDeleteClick(e, folder, 'Delete') }} className="storagedropdown pointerclass">
                        <span>  <i className="fas fa-trash-alt mr-3" />Delete</span>
                      </DropdownItem>
                      <DropdownItem href="" onClick={e => { onRestoreClick(e, folder) }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-trash-restore mr-3" />Restore</span>
                      </DropdownItem>
                    </div>
                    }
                    {!props.itstrash && <div>
                      {!showFilesModal && <><DropdownItem href="" onClick={e => { onMoveClick(e, folder, true) }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-file-export mr-3" />Move</span>
                      </DropdownItem>
                        <DropdownItem href="" onClick={e => { onCopyClick(e, folder, true) }} className="storagedropdown pointerclass">
                          <span>    <i className="fas fa-copy mr-3" />Copy</span>
                        </DropdownItem>
                        <DropdownItem href="" onClick={e => { onRenameClick(e, folder, true) }} className="storagedropdown pointerclass">
                          <span>    <i className="fas fa-edit mr-3" />Rename</span>
                        </DropdownItem>
                        <DropdownItem href="" onClick={e => { onCopyPathClick(e, folder, true) }} className="storagedropdown pointerclass">
                          <span> <i className="fas fa-copy mr-3" />Copy Path</span>
                        </DropdownItem></>}
                      <DropdownItem href="" onClick={e => { onDeleteClick(e, folder, 'Trash') }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-trash-alt mr-3" />Move to trash</span>
                      </DropdownItem>
                    </div>
                    }
                    <DropdownItem divider />
                    {isGetExtract && <div>
                      <DropdownItem href="" onClick={e => { onExtractClick(e, folder) }} className="storagedropdown pointerclass" disabled={!isFileAction}>
                        <span>  <i className="fas fa-box-open mr-3" />Extract</span>
                      </DropdownItem>
                    </div>
                    }
                    <DropdownItem href="" className="storagedropdown Permissioncolor" disabled>
                      <span>  <i className="fas fa-info-circle mr-3" />Permission</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </Col>
          }
        </Row>

      </div>
    )
  }
  for (const file of files) {
    const fileName = trimFileName(file.name)
    items.push(
      <div key={uuidv4()} >
        <Row
          key={uuidv4()}
          tag="a"
          className={isShowMenuName === fileName ? "py-2 storage-item folderitem active" : "py-2 storage-item folderitem"}
          data-id={fileName}
          onMouseEnter={e => { handleMouseHover(e, 'file', fileName) }}
          onMouseLeave={handleMouseLeave}
          title={fileName}
        >
          <Col md="10" xs="10" className="storagetxt" onContextMenu={e => e.preventDefault()}>
            <div className="overflowStyle">
              <span id={fileName}
                data-id={file.name}
                className="storage-file"
                onClick={e => {
                  e.stopPropagation()
                  onRowClick(e, 'file', file.name)
                }}          >
                &nbsp; <img src={findIcon(imageFileExtension(file.content_type))} alt="" ></img> &nbsp;
                {fileName}
              </span>
            </div>
          </Col>
          {isShowMenuName === fileName &&
            <Col md="2" xs="2" className="storagetxt" >
              <div className="">
                <UncontrolledDropdown direction="down">
                  <DropdownToggle tag="span" className="pointerclass"
                    onClick={e => e.preventDefault()}>
                    <i className="fas fa-ellipsis-v font12" />
                  </DropdownToggle>
                  <DropdownMenu persist right className="dropdown-menu-arrow" flip={false} modifiers={{
                    flip: {
                      behavior: "flip",
                      enabled: true
                    }, preventOverflow: { boundariesElement: 'window' }
                  }}>
                    <DropdownItem href="" onClick={e => { onViewClick(e, file.name) }} className="storagedropdown pointerclass">
                      <span> <i className="fas fa-binoculars mr-3" />View </span>
                    </DropdownItem>
                    <DropdownItem href="" onClick={e => { onDownloadClick(e, file.name) }} className="storagedropdown pointerclass" >
                      <span> <i className="fas fa-download mr-3" />Download </span>
                    </DropdownItem>
                    <DropdownItem href="" onClick={e => { onShareClick(e, file.name) }} className="storagedropdown pointerclass" >
                      <span>  <i className="fas fa-link mr-3"></i>Get Sharable Link</span>
                    </DropdownItem>
                    <DropdownItem divider />
                    {props.itstrash && <div>
                      <DropdownItem href="" onClick={e => { onDeleteClick(e, file.name, 'Delete') }} className="storagedropdown pointerclass">
                        <span>  <i className="fas fa-trash-alt mr-3" />Delete</span>
                      </DropdownItem>
                      <DropdownItem href="" onClick={e => { onRestoreClick(e, file.name) }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-trash-restore mr-3" />Restore</span>
                      </DropdownItem>
                    </div>
                    }
                    {!props.itstrash && <div>
                      {!showFilesModal && <><DropdownItem href="" onClick={e => { onMoveClick(e, file.name, false) }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-file-export mr-3" />Move</span>
                      </DropdownItem>
                        <DropdownItem href="" onClick={e => { onCopyClick(e, file.name, false) }} className="storagedropdown pointerclass">
                          <span>    <i className="fas fa-copy mr-3" />Copy</span>
                        </DropdownItem>
                        <DropdownItem href="" onClick={e => { onRenameClick(e, file.name, false) }} className="storagedropdown pointerclass" >
                          <span>  <i className="fas fa-edit mr-3"></i>Rename</span>
                        </DropdownItem>
                        <DropdownItem href="" onClick={e => { onCopyPathClick(e, file.name, false) }} className="storagedropdown pointerclass">
                          <span>    <i className="fas fa-copy mr-3" />Copy Path</span>
                        </DropdownItem></>}
                      <DropdownItem href="" onClick={e => { onDeleteClick(e, file.name, 'Trash') }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-trash-alt mr-3" />Move to trash</span>
                      </DropdownItem>
                    </div>
                    }
                    {isGetExtract && <div>
                      <DropdownItem href="" onClick={e => { onExtractClick(e, file.name) }} className="storagedropdown pointerclass" >
                        <span>  <i className="fas fa-box-open mr-3" />Extract</span>
                      </DropdownItem>
                    </div>
                    }
                    <DropdownItem divider />
                    <DropdownItem href="" className="storagedropdown disabled Permissioncolor" disabled>
                      <span>  <i className="fas fa-info-circle mr-3" />Permission</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </Col>
          }
        </Row>
      </div>
    )
  }
  if (nextPageToken !== null || nextPageToken === null) {
    items.push(
      <>
        <Row
          tag="a"
          className="nextPageTokenclass"
          key={uuidv4()}
        >
          <span className="folder">. </span>
          <Col md="7" xs="7" className="">

          </Col>
          <Col md="2" xs="2" className="storagetxt"></Col>
          <Col md="3" xs="3" className="storagetxt"></Col>
        </Row>
        {loadflagStorage && <Row>
          <Col className="textcenter">
            <ButtonGroup className="chatLoading verticalAligntxt">
              <Badge color="info"> Loading... </Badge>
            </ButtonGroup>
          </Col>
        </Row>}
        <Row>
          <Col className="textcenter">
            {nextPageToken !== null && loadmoreFlag && <ButtonGroup className="chatLoading verticalAligntxt">
              <Badge color="info"> Loading... </Badge>
            </ButtonGroup>}
          </Col>
        </Row>
        {nextPageToken === null && <Row>
          <Col className="textcenter">
            <span className="pageend">-- Page End --</span>
          </Col>
        </Row>}
      </>
    )
  }
  let itemsView;
  itemsView = items
  return (
    <div>

      {isShowContext &&
        <Row>
          <Col
            md="auto"
            id="context-menu"
            className="storage-context"
            style={contextMargin}
          >
            <ListGroup flush>
              <ListGroupItem
                disabled={!isFileAction}
                tag="a" data-type='context'
                onClick={onViewClick}
              >
                <i className="fas fa-binoculars mr-3" />View
              </ListGroupItem>
              <ListGroupItem
                disabled={!isFileAction}
                tag="a" data-type='context'
                onClick={onDownloadClick}
              >
                <i className="fas fa-download mr-3" />Download
              </ListGroupItem>
              <ListGroupItem
                disabled={!isFileAction}
                tag="a"
                data-type='context'
                onClick={onShareClick}>
                <i className="fas fa-link mr-3"></i>Get Sharable Link
              </ListGroupItem>
            </ListGroup>

            <hr />
            <ListGroup flush>

              {props.itstrash &&
                <ListGroup flush>
                  <ListGroupItem
                    tag="a" data-type='context'
                    onClick={e => { onDeleteClick(e, 'Delete') }}
                  >
                    <i className="fas fa-trash-alt mr-3" />Delete
                  </ListGroupItem>
                  <ListGroupItem
                    tag="a" data-type='context'
                    onClick={e => { onRestoreClick(e) }}
                  >
                    <i className="fas fa-trash-restore mr-3" />Restore
                  </ListGroupItem>
                </ListGroup>

              }

              {!props.itstrash &&
                <ListGroup flush>
                  <ListGroupItem disabled tag="a" data-type='context'>
                    <i className="fas fa-copy mr-3" />Duplicate
                  </ListGroupItem>
                  <ListGroupItem tag="a" data-type='context' onClick={e => { onMoveClick(e) }}>
                    <i className="fas fa-file-export mr-3" />Move
                  </ListGroupItem>
                  <ListGroupItem tag="a" data-type='context' onClick={e => { onCopyClick(e) }}>
                    <i className="fas fa-copy mr-3" />Copy
                  </ListGroupItem>
                  <ListGroupItem
                    tag="a" data-type='context' onClick={e => { onDeleteClick(e, 'Trash') }}>
                    <i className="fas fa-trash-alt mr-3" />Move to trash
                  </ListGroupItem>
                  {isGetExtract &&
                    <ListGroupItem
                      disabled={!isFileAction}
                      tag="a" data-type='context'
                      onClick={onExtractClick}
                    >
                      <i className="fas fa-box-open mr-3" />Extract
                    </ListGroupItem>
                  }


                </ListGroup>
              }
              <ListGroupItem
                disabled={!splitscreen || isFileAction}
                tag="a" data-type='context'
                onClick={e => { onPasteClick(e) }}>
                <i className="fas fa-paste mr-3" />Paste
              </ListGroupItem>


              <ListGroupItem disabled tag="a" data-type='context'>
                <i className="fas fa-file mr-3" />Rename
              </ListGroupItem>
              <ListGroupItem className="listpermission" data-type='context'>
                <i className="fas fa-info-circle mr-3" />Permission
              </ListGroupItem>

            </ListGroup>
          </Col>
        </Row>
      }
      {itemsView}
      <Modal
        centered
        className="rename-modal"
        isOpen={showRenameModal}
        toggle={toggleRenameModal}
        backdrop="static"
        returnFocusAfterClose={false}>
        <ModalHeader toggle={toggleRenameModal}>Rename</ModalHeader>
        <ModalBody>
          <Input
            placeholder="Folder Name"
            name="folderToBeCreate"
            className="inputRename"
            value={renameToBeCreate}
            onChange={handleRenameChange}
          />

          <Row>
            <Col sm="12" className="renamepopHint">
              <span className="notepopHint">Note: </span><span>Update reference of 'Renamed' folder/file in Project</span>
            </Col>
          </Row>
          <Row>
            <Col xl="12">
              <FormGroup>
                <Button
                  className="df-btn-primary btn-block"
                  size="sm"
                  type="submit"
                  onClick={e => renameUpdate(e)}>
                  Ok
                </Button>
              </FormGroup>
            </Col>
          </Row>

        </ModalBody>
      </Modal>
    </div>
  )
}
class StorageView extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      myContent: '',
      myContentChart: '',
      fileName: '',
      fileType: '',
      renderNotebook: '',
      myContents: [],
      DownloadUrl: '',
      delimiter: ',',
      delimiterName: ',',
      totalPages: 0,
      startIndex: 0,
      pageRecords: NO_OF_RECORDS,
      activePage: 1,
      totalRecords: 0,
      showCode: false,
      openMark: [""],
      advanceicon: "fas fa-plus-circle",
      markoptions: [],
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      storageId: "",
      rootFolder: "",
      storageName: "",
      platformDefault: false,
      errorFile: "",
      hideCode: "",
      contextMenuTable: false,
      showVersion: false,
      versionValue: false,
      listversion: [],
      showSaveModal: false,
      savecomments: '',
      showSavebutton: false,
      currentVersion: '',
      currentComments: '',
      showSaveasModal: false,
      fileToBeCreate: "",
      fileSize: '',
      smallfile: false,
      rowheader: false,
      showOriginal: false,
      hotSettings: [],
      readonlyTable: true,
      showHandsontable: false,
      versionName: null,
      NoData: false,
      savefrom: '',
      storageJobId: '',
      disableicon: false,
      jobState: '',
      count: 0,
      numPages: null,
      pdfPageNumber: 1,
      sheetName: [],
      keyValue: [],
      xlsxurl: '',
      getCopyText: false,
      csvData: [],
      btnNextState: false,
      isExistAnnotation:'',
      annotation: [],
      annotationIndex: [],
      copiedindex: ''
    }
    this.hotformula = {
      formulas: {
        engine: HyperFormula,
      },
      afterChange: function (r, c) {
        var data = this.getData();
      }
    }
    this.scrollToNode = this.scrollToNode.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateState = this.updateState.bind(this);
    this.saveCommentschange = this.saveCommentschange.bind(this);
    this.hotTableComponent = React.createRef();

  }
  editHandsontable = () => {
    this.setState({
      readonlyTable: false, contextMenuTable: true,
    })
  }
  saveHandsontable = (fileName) => {
    let content = this.state.annotation;
    let contentType = 'application/octet-stream';
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    if (fileName) {
      const fileNameOnly = fileName.split('.')[0];
      fileName = fileNameOnly + "." + "json";
    }

    StorageService.uploadAnnotationUrl(fileName, this.state.storageId, this.state.rootFolder)
      .then((response) => {
        if (response.type === "GOOGLE") {
          axios({
            url: response.upload_url,
            baseURL: '',
            data: {},
            headers: {
              'content-type': contentType,
              'x-goog-resumable': 'start'
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            const resumableLink = resp.headers.location
            CommonService({
              url: resumableLink,
              baseURL: '',
              data: content,
              headers: {
                'content-type': "multipart/form-data"
              },
              method: 'PUT',
              cancelToken: source.token,
            }).then((resp) => {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);
              this.setState({ showSaveModal: false, showVersion: false, loading: false, showSavebutton: false, contextMenuTable: true, readonlyTable: false });
            })
          });
        } else if (response.type === "AWS") {
          var rest = response.fields;
          var formData = new FormData();
          for (const [key, value] of Object.entries(rest)) {
            formData.append(key, value)
          }
          formData.append("file", content)
          axios({
            url: response.upload_url,
            data: formData,
            headers: {
              'content-type': "multipart/form-data"
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);
            this.setState({ showSaveModal: false, showVersion: false, loading: false, showSavebutton: false, contextMenuTable: true, readonlyTable: false })
          })
        }
      });

  }

  saveHandsontable_old = (fileName) => {
    this.setState({ readonlyTable: true, loading: true, showSaveModal: false })
    let contentType = 'application/octet-stream'
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    let onlyValue = this.hotTableComponent.current.hotInstance.getData();
    this.state.hotSettings = onlyValue;
    this.setState({ hotSettings: onlyValue })
    let content = arrayToCSV(this.state.hotSettings)
    let currentUser = JSON.parse(localStorage.getItem("UserProfile"))
    let apitoken = currentUser.apiToken;
    let createdBy = currentUser.firstName + currentUser.lastName;
    let storageId = this.state.storageId.storageId
    let rootFolder = this.state.rootFolder.rootFolder
    let savefiledata = {
      "filePath": fileName,
      "versionInfo": {
        "comment": this.state.savecomments,
        "createdAt": moment.utc(new Date()).local().format('MMM DD, YYYY HH:mm a'),
        "createdBy": createdBy
      }
    }
    let sourceStorage = {}
    if (storageId !== null && storageId !== undefined && storageId !== "") {
      sourceStorage.storageId = storageId
    }
    if (rootFolder !== null && rootFolder !== undefined && rootFolder !== "") {
      sourceStorage.rootFolder = rootFolder
    }
    if (Object.keys(sourceStorage).length > 0) {
      sourceStorage.apiKey = apitoken
      savefiledata.sourceStorage = sourceStorage
    }
    StorageService.uploadObjectUrl(fileName, this.state.storageId, this.state.rootFolder)
      .then((response) => {
        if (response.type === "GOOGLE") {
          axios({
            url: response.upload_url,
            baseURL: '',
            data: {},
            headers: {
              'content-type': contentType,
              'x-goog-resumable': 'start'
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            const resumableLink = resp.headers.location
            CommonService({
              url: resumableLink,
              baseURL: '',
              data: content,
              headers: {
                'content-type': "multipart/form-data"
              },
              method: 'PUT',
              cancelToken: source.token,
            }).then((resp) => {
              FileJobsService.SaveVersion(savefiledata)
                .then((response) => {
                  toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);
                  this.setState({ showSaveModal: false, showVersion: false, loading: false, showSavebutton: false, contextMenuTable: true })
                });
            })
          });
        } else if (response.type === "AWS") {
          var rest = response.fields;
          var formData = new FormData();
          for (const [key, value] of Object.entries(rest)) {
            formData.append(key, value)
          }
          formData.append("file", content)
          axios({
            url: response.upload_url,
            data: formData,
            headers: {
              'content-type': "multipart/form-data"
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);
            this.setState({ showSaveModal: false, showVersion: false, loading: false, showSavebutton: false, contextMenuTable: true })
            FileJobsService.SaveVersion(savefiledata)
              .then((response) => {
                toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);
                this.setState({ showSaveModal: false, showVersion: false, loading: false, showSavebutton: false, contextMenuTable: true })
              });
          })
        }
      });
  }
  scrollToNode = (node) => {
    const titleElement = document.getElementById(node)
    titleElement.scrollIntoView({ behavior: 'smooth' })
    this.setState({ clickId: node });
    this.state.clickId = node;
  }
  componentDidMount = () => {
    this.renderFileView();
    const url = window.location.href
    let myPath = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('file')
    document.title = "DecisionForce - " + myPath
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  reloadData = () => {
    this.renderFileView();
    if (this.state.showVersion) {
      this.setState({
        showVersion: false
      }, () => {
        this.callVersion(this.state.showVersion, this.state.fileName, this.state.storageId, this.state.rootFolder);
      })
    }
  }

  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
  }
  renderFileView = () => {
    this.setState({ loading: true });
    const url = window.location.href
    let myPath = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('file')
    let sId = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('storage')
    let root = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('root')
    let storageName = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('storageName')
    let platformDefault = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('platformDefault')
    let hideCodeCells = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('hideCodeCells')
    let fileSize = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('filesize')
    let version = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('version')
    let ext = myPath.substring(myPath.lastIndexOf(".") + 1)
    this.setState({
      fileName: (myPath === null || myPath === undefined) ? "" : myPath,
      fileType: ext,
      storageId: (sId === null || sId === undefined) ? "" : sId,
      rootFolder: (root === null || root === undefined) ? "" : root,
      storageName: (storageName === null || storageName === undefined) ? "" : storageName,
      platformDefault: (platformDefault === null || platformDefault === undefined) ? false : (platformDefault === 'true' ? true : false),
      hideCode: hideCodeCells,
      fileSize: fileSize,
      loading: false
    })
    if (fileSize > 2097152) {
      this.setState({ smallfile: false })
    }
    else {
      this.setState({ smallfile: true })
    }
    if (typeof version === "string" && (version === null || version === "null")) {
      this.downloadObj(myPath, sId, root);
    } else if (typeof version === "string" && (version !== null || version !== "null")) {
      this.downloadVersionFiles(myPath, version, sId, root)
    } else if (typeof version === "object" && version === null) {
      this.downloadObj(myPath, sId, root);
    }
    this.checkOriginalVersion(myPath, sId, root);
  }

  checkOriginalVersion = (originalPath, storageId, rootFolder) => {
    this.setState({ loading: true })
    let prefix = originalPath + '/';
    let pageToken = null;
    StorageService.listVersionObjects(prefix, null, storageId, rootFolder, pageToken)
      .then((response) => {
        this.setState({ listversioning: response.result });
        if (response.result.length === 0) {
          this.saveOriginalVersion(originalPath, storageId, rootFolder);
          this.setState({ disableicon: true })
        }
        else {
          this.setState({ disableicon: false })
        }
      }).catch((error) => {
      })
  }

  saveOriginalVersion = (filePath, storageId, rootFolder) => {
    let originaldata = {
      "filePath": filePath,
    }
    let sourceStorage = {}
    if (storageId !== null && storageId !== undefined && storageId !== "") {
      sourceStorage.storageId = storageId
    }
    if (rootFolder !== null && rootFolder !== undefined && rootFolder !== "") {
      sourceStorage.rootFolder = rootFolder
    }
    if (Object.keys(sourceStorage).length > 0) {
      originaldata.rootFolder = sourceStorage
      originaldata.sourceStorage = sourceStorage
    }
    FileJobsService.ViewOriginalVersion(originaldata)
      .then((response) => {
        let sJobId = response.jobId;
        setTimeout(() => this.getStorageJobId(sJobId, this.state.count), VERSIONTIMEOUT);
      });
  }

  getStorageJobId = (storageJobId, count) => {
    FileJobsService.GetStorageJobId(storageJobId)
      .then((response) => {
        if (response.jobStateList !== null && response.jobStateList !== []) {
          if (response.jobStateList.length > 0) {
            let jobState = response.jobStateList[0].jobState;
            this.setState({ jobState: jobState })
            this.setJobState(jobState, storageJobId, count)
          }
        }
      });
  }

  setJobState = (jobState, storageJobId, count) => {
    if (jobState === "FINISHED") {
      this.setState({ disableicon: false })
    }
    else if (jobState === "ERROR") {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Error in Creating Original Version</b></i>);
      this.setState({ disableicon: false })
    }
    else if (jobState === "PROCESSING") {
      this.setState({ count: count + 1 })
      if (this.state.count <= 5) {
        setTimeout(() => this.getStorageJobId(storageJobId, this.state.count), VERSIONTIMEOUT);
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Error in Creating Original Version</b></i>);
        this.setState({ disableicon: false })
      }
    }
  }

  downloadObj = (filePath, sId, root) => {
    if (filePath) {
      let dataRenderObject = {
        filePath: filePath,
        storageId: sId,
        rootPath: root,
        version: "",
        startIndex: 0,
        delimiter: this.state.delimiter

      }
      const extension = filePath.substring(filePath.lastIndexOf(".") + 1)
      if (extension === "csv") {
        this.tableRendering(dataRenderObject)
      }
      else {
        StorageService.downloadObjectUrl(filePath, sId, root)
          .then((response) => {
            if (response !== null && response !== undefined && response.hasOwnProperty("download_url")) {
              this.renderText(response.download_url);
              this.setState({ DownloadUrl: response.download_url });
            }
          }).catch((error) => {
            this.state.fileType = 'png'
            this.state.myContent = page404
            this.state.fileName = 'File Not Found!!!'
            this.setState({ loading: false });
          });
      }
    }
  }

  tableRendering = (dataRenderObject) => {
    this.setState({
      loading: true
    });

    const objectParam = {
      "pageRecords": NO_OF_RECORDS,
      "currentPage": dataRenderObject.startIndex,
      "version": dataRenderObject.version,
      "delimiter": dataRenderObject.delimiter
    };
    DRSService.rendering(dataRenderObject.filePath, dataRenderObject.storageId, dataRenderObject.rootPath, objectParam)
      .then((response) => {
        this.bindFileData(response)
        this.setState({
          loading: false
        });
      }).catch((error) => {
        this.setState({ loading: false, btnNextState: true });
        if (error.status_code == 404) {
          this.state.fileType = 'png'
          this.state.myContent = page404
          this.state.fileName = 'File Not Found!!!'
        }
      });
  }

  bindFileData = (response) => {
    this.setState({
      readonlyTable: true,
      contextMenuTable: false
    })
    if (response.data !== null && response.data.length > 0) {
      this.loadHandsonTable(response.data);
      this.setState({
        showHandsontable: true,
        btnNextState: false,
        pageRecords: response.total_records,
        startIndex: response.start_index
      });
    }
    else {
      this.setState({ NoDataText: "---- No Data Found ----", NoData: true })
    }

  }

  downloadVersionFiles = (filePath, version, sId, root) => {
    if (filePath) {
      const extension = filePath.substring(filePath.lastIndexOf(".") + 1)
      let dataRenderObject = {
        filePath: filePath,
        storageId: sId,
        rootPath: root,
        version: version,
        pageNumber: "",
        startIndex: 0,
        delimiter: this.state.delimiter
      }
      this.setState({
        startIndex: 0
      });
      if (extension === "csv") {
        this.tableRendering(dataRenderObject)
      }
      else {
        StorageService.downloadVersionFilesUrl(filePath, version, sId, root)
          .then((response) => {
            if (response !== null && response !== undefined && response.hasOwnProperty("download_url")) {
              this.renderText(response.download_url);
              this.setState({ DownloadUrl: response.download_url });
            }
          }).catch((error) => {
            this.state.fileType = 'png'
            this.state.myContent = page404
            this.state.fileName = 'File Not Found!!!'
            this.setState({ loading: false });
          });
      }
    }
  }
  // Download particular file in input or code
  downloadparticularFiles = (fileName) => {
    StorageService.downloadObjectUrl(fileName, this.state.storageId, this.state.rootFolder)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.download_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }
  csvLoadData = (page) => {
    let dataRenderObject = {
      filePath: this.state.fileName,
      storageId: this.state.storageId,
      rootPath: this.state.rootFolder,
      version: this.state.version,
      pageNumber: page,
      delimiter: this.state.delimiter
    }
    this.tableRendering(dataRenderObject)
  }
  handlePrevPageClick = (e) => {
    let start_idx = (this.state.startIndex - ((this.state.pageRecords + NO_OF_RECORDS)))
    if (0 <= start_idx) {
      let dataRenderObject = {
        filePath: this.state.fileName,
        storageId: this.state.storageId,
        rootPath: this.state.rootFolder,
        version: this.state.version,
        startIndex: start_idx,
        delimiter: this.state.delimiter
      }
      this.tableRendering(dataRenderObject)
    }
  }
  handleNextPageClick = (pageNumber) => {
    let dataRenderObject = {
      filePath: this.state.fileName,
      storageId: this.state.storageId,
      rootPath: this.state.rootFolder,
      version: this.state.version,
      startIndex: this.state.startIndex,
      delimiter: this.state.delimiter
    }
    this.tableRendering(dataRenderObject)
  };
  loadHandsonTable = (jsonCsv) => {
    this.setState({ hotSettings: jsonCsv })
  }
  renderText = (url) => {
    this.setState({
      loading: true
    })
    if (this.state.fileType === "jpeg" || this.state.fileType === "jpg" ||
      this.state.fileType === "png") {
      this.setState({
        myContent: url,
        loading: false
      })
    }
    else if (this.state.fileType === "pdf") {
      this.setState({
        myContent: url,
        loading: false
      })
    }
    else if (this.state.fileType === "xlsx" || this.state.fileType === "xls") {
      var url = url;
      this.setState({ xlsxurl: url })
      var req = new XMLHttpRequest();
      req.open("GET", url, true);
      var result = [];
      req.responseType = "arraybuffer";
      req.onload = (e) => {
        var data = new Uint8Array(req.response);
        var wb = XLSX.read(data, { type: "array" });
        const sheet = wb.Sheets;
        let filtervalues = "";
        this.setState({
          keyValue: sheet
        }, () => {
          filtervalues = Object.values(this.state.keyValue);
        })
        for (const [key, value] of Object.entries(sheet)) {
          const ws = wb.Sheets[key];
          let list = this.state.sheetName.push(key);
          const html = XLSX.utils.sheet_to_csv(filtervalues[0]);
          result = CSVToJSONs(html, ',');
          this.setState({
            hotSettings: result,
            loading: false,
            activeExcel: this.state.sheetName[0]
          })
        }
      };
      req.send();
    }
    else {
      axios.get(url)
        .then(response => {
          if (this.state.fileType === "ipynb") {
            let notebook = response.data
            this.setState({
              loading: false
            }, () => {
              this.getNotebookCellsData(notebook);
            })
          }
          else {
            this.setState({
              fileType: "others",
              myContent: response.data.toString(),
              loading: false

            })
          }
        });
    }
  }

  getTabData = (tabid) => {
    var result = [];
    let filteredTabData = Object.fromEntries(Object.entries(this.state.keyValue).filter(([key]) => key.includes(tabid)));
    let filtervalues = Object.values(filteredTabData);
    for (const [key, value] of Object.entries(filtervalues[0])) {
      const html = XLSX.utils.sheet_to_csv(filtervalues[0]);
      result = CSVToJSONs(html, ',');
      this.setState({
        hotSettings: result,
        loading: false,
        activeExcel: tabid
      })
    }
  }

  getNotebookCellsData = (notebook) => {
    let options = []
    let opencell = []
    if (Array.isArray(notebook.cells)) {
      if (notebook.cells.length !== 0) {
        let count = 1;
        let contentid = 1;
        for (var i = 0; i < notebook.cells.length; i++) {
          if (!notebook.cells[i].metadata.hasOwnProperty("decisionforce_cell_id")) {
            let metatab = { "decisionforce_cell_id": uuidv4() }
            notebook.cells[i].metadata = metatab

          }
          if (notebook.cells[i].cell_type === "code") {
            notebook.cells[i].metadata.codeindex = count++;
            opencell.push({
              name: notebook.cells[i].metadata.decisionforce_cell_id,
            })
            this.state.opencellid = opencell
          }
          if (notebook.cells[i].cell_type === "markdown") {
            if (typeof (notebook.cells[i].source) === "string") {
              if (notebook.cells[i].source.substring(0, 20).includes('#')) {
                options.push({
                  name: notebook.cells[i].source,
                })
                notebook.cells[i].metadata.contentid = contentid++;
                this.setState({
                  markoptions: options
                })
                this.state.markoptions = options
              }
            }
            if (typeof (notebook.cells[i].source) === "object") {
              if (notebook.cells[i].source[0].toString().substring(0, 20).includes('#')) {
                options.push({
                  name: notebook.cells[i].source[0],
                })
                notebook.cells[i].metadata.contentid = contentid++;
                this.setState({
                  markoptions: options
                })
                this.state.markoptions = options
              }
            }
          }


        }
      }
      this.setState({
        myContent: notebook.cells,
        loading: false
      })
    }
    if (this.state.hideCode === "true") {
      this.closeMarkToggle();
      this.setState({ showCode: false })
    }
    else {
      this.expandMarkToggle();
      this.setState({ showCode: true })

    }
  }
  collapsesToggle = collapse => {
    let openedCollapses = this.state.openedCollapses;

    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: []
      });
    } else {
      this.setState({
        openedCollapses: [collapse]
      });
    }

  };
  // transpose the array
  transpose = (arr) => {
    return Object.keys(arr[0]).map(function (c) {
      return arr.map(function (r) {
        if (r[c] === null) {
          r[c] = "";
        }
        return r[c];
      });
    });
  }
  csvToArray = (csv) => {
    let delimiter = ",";
    var rows = csv.split("\n");
    return rows.map(function (row) {
      return row.split(delimiter);
    });
  }
  handleChangeSelectDelimiter = (event) => {
    this.setState({
      myContent: this.state.myContent,
      startIndex: 0,
      delimiter: event.value
    });
    let dataRenderObject = {
      filePath: this.state.fileName,
      storageId: this.state.storageId,
      rootPath: this.state.rootFolder,
      version: "",
      startIndex: 0,
      delimiter: event.value

    }
    this.tableRendering(dataRenderObject)
  }
  collapsesMarkToggle = (collapse) => {
    let openMark = this.state.openMark;
    if (openMark.includes(collapse)) {
      this.setState({
        openMark: [],
      });
    } else {
      this.setState({
        openMark: [collapse],
      });
    }
  };
  callCode = (codevalue) => {
    if (codevalue === false) {
      this.expandMarkToggle();
    }
    else {
      this.closeMarkToggle();
    }
  }
  callVersion = (versionvalue, fileName, storageId, rootFolder) => {
    this.setState({ loading: true });
    if (versionvalue === false) {
      this.setState({
        showVersion: true
      }, () => {

        let senddata = {
          "fileName": fileName,
          "storageId": storageId,
          "rootFolder": rootFolder
        }
        this.state.listversion = senddata;
      })
      this.setState({ loading: false });
    }
    else {
      this.state.showVersion = false;
      this.setState({ loading: false });
    }
  }
  updateState(filename, storageId, rootFolder, version, comments) {
    if (filename) {
      this.setState({ loading: true, showOriginal: false, startIndex: 0 });
      let dataRenderObject = {
        filePath: filename,
        storageId: storageId,
        rootPath: rootFolder,
        version: version,
        startIndex: 0,
        delimiter: this.state.delimiter

      }
      const extension = filename.substring(filename.lastIndexOf(".") + 1)
      if (extension === "csv") {
        this.tableRendering(dataRenderObject)
      }
      else {
        StorageService.ViewVersionObjects(filename, storageId, rootFolder, version)
          .then((response) => {
            this.renderText(response.download_url);
            this.setState({ DownloadUrl: response.download_url });
            this.setState({ currentVersion: version, currentComments: comments, loading: false })
          }).catch((error) => {
          })
      }
    }
  }
  expandMarkToggle = () => {
    let codelength = this.state.opencellid;
    let allcode = []
    for (var j = 0; j < codelength.length; j++) {
      allcode.push(codelength[j].name)
    }
    this.setState({
      openMark: allcode,
    });
  }
  closeMarkToggle = () => {
    this.setState({
      openMark: [],
    });
  }

  setCellMetaData = (row, col, source, val) => {
    if (source === 'comment' && val.value && this.state.isExistAnnotation !== val.value.trim()) {
      let celIndex = { 'row': row, 'col': col }
      this.state.isExistAnnotation=val.value.trim();         
      let annotationList = val.value.split('\n')
      for (let annotation of annotationList) {
        let content = annotation.split("=")
        if (content && content !== null && 0 < content.length) {
          let keyExistis = this.state.annotation.filter(item => item.key === content[0]);
          let index = this.state.annotation.findIndex(item => item.key === content[0]);
          if (keyExistis.length === 1) {
            if (index !== -1) {
              let cellItem = { 'value': content[1].trim(), 'index': celIndex }
              keyExistis[0].values.push(cellItem)
            }
          } else {
            let value = []
            if (content[1] !== undefined && content[1] !== "") {
              value.push({ 'value': content[1], 'index': celIndex })
              var comment = {
                'key': content[0].trim(),
                'values': value
              }
              this.state.annotation.push(comment)
            }
          }
        }
      }

    }
  }
  toggleSaveModal = (from) => {
    this.setState({
      showSaveModal: !this.state.showSaveModal,
      savecomments: '',
      savefrom: from
    })
  }
  saveCommentschange = (event) => {
    if (event !== null) {
      this.setState({ savecomments: event.target.value });
      if (this.state.savecomments !== null && this.state.savecomments.length > 3 && this.state.savecomments.length < 100) {
        this.setState({ showSavebutton: true })
      }
      else {
        this.setState({ showSavebutton: false })
      }
    }
  }
  showOriginal = (value) => {
    if (value === true) {
      this.setState({
        showOriginal: true, selectedVersionName: 'Latest', currentVersion: '', showVersion: true,
        currentComments: '',
      })
    }
    else {
      this.setState({
        showOriginal: false, selectedVersionName: 'Latest', currentVersion: '', showVersion: true,
        currentComments: '',
      })

    }
  }
  toggleSaveas = () => {
    if (this.state.showSaveasModal) {
      this.setState({ showSaveasModal: false, loading: false })
    } else {
      this.fetchStorageItems(this.state.currFolder, null, false);
      this.setState({ showSaveasModal: true, fileToBeCreate: "", loading: false })
    }
  }
  _fetchStorageItems = (prefix, pageToken, files, folders) => {
    this.setState({
      loading: "block"
    });
    let storageName = this.state.showFilesModal === true ? this.state.destinationStorageId : this.state.sourceStorageId;
    let rootFolder = this.state.showFilesModal === true ? this.state.destinationRootFolder : this.state.sourceRootFolder;
    StorageService.listObjects(prefix, storageName, rootFolder, pageToken)
      .then((response) => {
        files = [...files, ...response.result]
        folders = [...folders, ...response.prefixes]

        if (response.next_page_token) {
          this.state.nextPageToken = response.next_page_token
        } else {
          this.state.nextPageToken = null
        }
        this.setState({ folders: folders, filterfolder: folders, loading: "none", tabloading: false, loadflagStorage: false })
        this.setState({ files: files, filterfiles: files, loading: "none", tabloading: false, loadflagStorage: false })
        this.setState({ currFolder: prefix })
        this.constructNavigation()
      })
  }
  fetchStorageItems = (prefix, deselectAll) => {
    if (deselectAll) {
      deselectAll()
    }
    this.setState({
      files: [],
      folders: [],
      nextPageToken: null,
      FilterFilesData: [],
      FilterFolderData: [],
      loading: false
    })
    this._fetchStorageItems(prefix, null, [], [])
  }
  constructNavigation = () => {
    let currFolder = this.state.currFolder
    let homeNav =
      <div className="breadcrumb-wrap" key={uuidv4()} active>
        <a href={() => false} data-name=''><i className="fas fa-folder mr-3"></i>/</a>
      </div>
    if (currFolder) {
      homeNav =
        <div className="breadcrumb-wrap" key={uuidv4()} >
          <a href={() => false} data-name='' onClick={this.onNavigationClick}><i className="fas fa-folder mr-3"></i> </a>
        </div>
    }
    let navigations = [
      homeNav
    ]
    if (currFolder) {
      let prefixes = currFolder.split('/').slice(0, -1)
      let lastPrefix = prefixes.length > 0 ? prefixes.pop() : null
      let name = ''
      for (const prefix of prefixes) {
        name = name + prefix + '/'
        navigations.push(
          <div className="breadcrumb-wrap" key={uuidv4()}>
            <span className="sep"><i className="fa fa-caret-right"></i></span> <span className="breadcrumb overflowStyleTree" title={prefix}><a href={() => false} data-name={name} onClick={this.onNavigationClick}>{prefix}</a></span>
          </div>
        )
      }
      if (lastPrefix) {
        navigations.push(
          <div className="breadcrumb-wrap active" key={uuidv4()}>
            <span className="sep"><i className="fa fa-caret-right"></i></span> <span className="breadcrumb overflowStyleTree" title={lastPrefix}>{lastPrefix}</span>
          </div>
        )
      }
    }
    this.setState({ storageNavigations: navigations })
  }
  onNavigationClick = (event) => {
    event.preventDefault()
    this.fetchStorageItems(event.target.dataset.name)
  }
  handleInputChangeFile = (event) => {
    const target = event.target
    const value = target.value.replace(/[^\w\s]/gi, "")
    const name = target.name
    this.setState({
      [name]: value
    })
  }
  createFileInit = (fileName, path) => {
    if (fileName.trim() === "") {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please Enter file name</b></i>);

    } else {
      let creatednewfile = fileName + '.csv';
      if ((path === undefined) || (path === null)) {
        path = "";
      }

      let newpath = path + creatednewfile;
      let checkIndex = this.state.files.findIndex(item => item.name.split("/").pop() === creatednewfile)
      if (checkIndex < 0) {
        this.SaveasHandsontable(creatednewfile, newpath, path)
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">File already exists, Please create new file name</b></i>);

      }
    }
  }
  SaveasHandsontable = (creatednewfile, newpath, path) => {
    this.setState({ readonlyTable: true, loading: false, showSaveModal: false })
    let contentType = 'application/octet-stream'
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    let onlyValue = this.hotTableComponent.current.hotInstance.getData();
    this.state.hotSettings = onlyValue;
    this.setState({ hotSettings: onlyValue })
    let content = arrayToCSV(this.state.hotSettings)
    let currentUser = JSON.parse(localStorage.getItem("UserProfile"))
    let apitoken = currentUser.apiToken;
    let createdBy = currentUser.firstName + currentUser.lastName;
    let storageId = this.state.storageId.storageId
    let rootFolder = this.state.rootFolder.rootFolder
    let savefiledata = {
      "filePath": newpath,
      "versionInfo": {
        "comment": this.state.savecomments,
        "createdAt": moment.utc(new Date()).local().format('MMM DD, YYYY HH:mm a'),
        "createdBy": createdBy
      }
    }

    let sourceStorage = {}
    if (storageId !== null && storageId !== undefined && storageId !== "") {
      sourceStorage.storageId = storageId
    }
    if (rootFolder !== null && rootFolder !== undefined && rootFolder !== "") {
      sourceStorage.rootFolder = rootFolder
    }
    if (Object.keys(sourceStorage).length > 0) {
      sourceStorage.apiKey = apitoken
      savefiledata.sourceStorage = sourceStorage
    }

    StorageService.uploadObjectUrl(newpath, this.state.storageId, this.state.rootFolder)
      .then((response) => {
        if (response.type === "GOOGLE") {
          axios({
            url: response.upload_url,
            baseURL: '',
            data: {},
            headers: {
              'content-type': contentType,
              'x-goog-resumable': 'start'
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            const resumableLink = resp.headers.location
            CommonService({
              url: resumableLink,
              baseURL: '',
              data: content,
              headers: {
                'content-type': "multipart/form-data"
              },
              method: 'PUT',
              cancelToken: source.token,
            }).then((resp) => {
              FileJobsService.SaveVersion(savefiledata)
                .then((response) => {
                  toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);
                  this.setState({ showSaveModal: false, showVersion: false, showSaveasModal: false, loading: false })
                });
              this.setState({ loading: false })

            })
          });

        } else if (response.type === "AWS") {
          var rest = response.fields;
          var formData = new FormData();
          for (const [key, value] of Object.entries(rest)) {
            formData.append(key, value)
          }
          formData.append("file", content)
          axios({
            url: response.upload_url,
            data: formData,
            headers: {
              'content-type': "multipart/form-data"
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);
            this.setState({ showSaveModal: false, loading: false, contextMenu: false })
            this.fetchStorageItems(this.state.currFolder, null, false);
            FileJobsService.SaveVersion(savefiledata)
              .then((response) => {
                toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);
                this.setState({ showSaveModal: false, showVersion: false, showSaveasModal: false, loading: false, contextMenu: false })
                this.fetchStorageItems(this.state.currFolder, null, false);

              });
          })
        }
      });
  }
  handleRowHeader = (rowvalue) => {
    this.state.rowheader = rowvalue;
  }
  renderer = (instance, TD, row, col, prop, value, cellProperties) => {
    TD.innerHTML = "";
    if (value) {
      if (row === 0) {
        TD.className = 'headercolor'
        TD.innerHTML = value;
      } else {
        TD.className = 'gray'
        TD.innerHTML = value;
      }
    }
    return TD;
  };
  handlerangeClick = (e, name, index) => {
    this.setState({ getCopyText: true, copiedindex: index })
    setTimeout(() => {
      this.setState({ getCopyText: false })
    }, 3000);
    switch (e.detail) {
      case 1:
        // single click event 
        this.onCopyOutputClick(name, index);
        break;
      default:
        break;
    }
  };
  onCopyOutputClick = (name, index) => {
    var range = document.createRange();
    range.selectNode(document.getElementById("outputContents" + index));
    window.getSelection().removeAllRanges(); // clear current selection
    window.getSelection().addRange(range); // to select text
    document.execCommand("copy");
    window.getSelection().removeAllRanges();// 
  }
  render() {
    return (

      <>
        <PanelHeader size="sm" />
        <div className="content" style={{ maxHeight: '80px' }}>
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
            <Row className="justify-content-center">
              <Col lg={12} md={12} xs={12}>
                <Card>
                  <CardHeader>
                    <Row className="align-items-center">
                      <Col xs={this.state.fileType !== "ipynb" && this.state.fileType !== "csv" ? "8" : "6"}>
                        <Row className="textLeft pointerclass" >
                          {this.state.platformDefault && <Col xs="12" className="p-0">
                            <span title={this.state.fileName} className="overflowStyleNotebook p-0"> &nbsp;&nbsp;File : {this.state.fileName}
                            </span>
                          </Col>}
                          {!this.state.platformDefault && <Col xs="12" className="p-0">
                            <span title={this.state.fileName} className="overflowStyleNotebook p-0">
                              &nbsp;&nbsp;File : <span className="text-primary p-0">{this.state.storageName + "/" + this.state.rootFolder}</span>/
                              {this.state.fileName}
                            </span>
                          </Col>}
                        </Row>
                      </Col>
                      {this.state.fileType === "ipynb" && <Col xs="2" className="text-right">
                        <div>
                          <span onClick={e => { e.preventDefault(); this.setState({ showCode: !this.state.showCode }); this.callCode(this.state.showCode) }} className="pointerclass">
                            <i className={this.state.showCode ? "fas fa-minus-circle codeclass" : "fas fa-plus-circle codeclass"}  ></i> <b className="codeclass">Code </b>
                          </span>
                        </div>
                      </Col>
                      }
                      {this.state.fileType === "csv" && <Col xs="2" style={{ float: "right" }}>
                        <Select name="delimiterName" value={delimiteroptions.filter(item => item.value === this.state.delimiter)}
                          options={delimiteroptions} onChange={this.handleChangeSelectDelimiter} noValidate />
                      </Col>}
                      <Col xs="3" className="text-right">
                        {this.state.fileType === "csv" &&
                          <span className="pointerclass mr-3">
                            <i className={this.state.disableicon === true ? "fas fa-sync disable-icon" : "fas fa-sync text-primary"} title="Reload" onClick={this.reloadData}></i>
                          </span>
                        }
                        {this.state.fileType === "csv" &&
                          <span className="pointerclass">
                            <i className={(this.state.rowheader === true ? "fas fa-grip-horizontal saveastxtbox" : "fas fa-grip-horizontal") || (this.state.disableicon === true ? "fas fa-grip-horizontal saveastxtbox disable-icon" : "fas fa-grip-horizontal")}
                              title={this.state.rowheader === false ? "First Row as Header" : "Default Header"}
                              onClick={e => {
                                e.preventDefault();
                                this.setState({ rowheader: !this.state.rowheader });
                                this.handleRowHeader(this.state.rowheader)
                              }} ></i>  &nbsp; &nbsp;</span>
                        }

                        {(this.state.fileType === "csv" && this.state.smallfile === true) && <i className={this.state.disableicon === true ? "fas fa-history disable-icon" : "fas fa-history green-text pointerclass"} title="Version History" id="Version" onClick={e => { e.preventDefault(); this.setState({ showVersion: !this.state.showVersion }); this.callVersion(this.state.showVersion, this.state.fileName, this.state.storageId, this.state.rootFolder) }}></i>} &nbsp; &nbsp;
                        <i className={this.state.disableicon === true ? "fas fa-download disable-icon" : "fas fa-download pink-text fa-sm pointerclass"} title="Download" onClick={e => this.downloadparticularFiles(this.state.fileName)}></i>  &nbsp; &nbsp;
                        {this.state.smallfile === true && this.state.readonlyTable === true && this.state.fileType === "csv" && <i className={this.state.disableicon === true ? "fas fa-edit disable-icon" : "fas fa-edit df-text-primary pointerclass"} title="Edit" id="Edit" onClick={this.editHandsontable}></i>} &nbsp; &nbsp;
                        {this.state.smallfile === true && this.state.readonlyTable === false && this.state.fileType === "csv" && <i className={this.state.disableicon === true ? "fas fa-save disable-icon" : "fas fa-save df-text-primary pointerclass"} title="Save" id="Edit" onClick={e => this.toggleSaveModal('Save')}></i>} &nbsp;
                        &nbsp; &nbsp; {this.state.smallfile === true && this.state.readonlyTable === false && this.state.fileType === "csv" && <i className={this.state.disableicon === true ? "fas fa-file-signature disable-icon" : "fas fa-file-signature btn-dribbble pointerclass"} title="Save as" id="Edit" onClick={this.toggleSaveas}></i>}
                      </Col>
                      <Col xs="1">
                        <Link to="storage" >
                          <span className="close clear-filter">× &nbsp;</span>
                        </Link>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody style={{ padding: "1px 15px 15px 15px" }}>
                    <Scrollbars autoHeight autoHeightMin={this.state.sheight - 180}>
                      <div className="carcontent">
                        <Row>
                          <Col xs={12} sm={this.state.fileType === "ipynb" ? 2 : (this.state.showVersion === true && this.state.fileType === "csv") ? 12 : 10} className="tblofcontentborder">
                            {this.state.fileType === "ipynb" && <div>
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight - 180}>
                                <h5 className="tblofcontent">Table of Content</h5>
                                {this.state.markoptions !== "" ? this.state.markoptions.map((itm, ind) => (
                                  <Row className="pointerclass">
                                    <ol start={ind + 1}>
                                      <li>
                                        <div onClick={() => this.scrollToNode(ind + 1)} className={this.state.clickId === ind + 1 ? 'activeLink markdiv' : 'markdiv'} >
                                          <MarkDown markdownValue={itm.name} className="markdwntxt" ></MarkDown>
                                        </div>
                                      </li>
                                    </ol>

                                  </Row>
                                )) : <div key={uuidv4()}></div>}
                              </Scrollbars>
                            </div>
                            }
                          </Col>
                          <Col xs={12} sm={this.state.fileType === "ipynb" ? 10 : (this.state.showVersion === true && this.state.fileType === "csv") ? 10 : 12}>
                            {this.state.fileType !== "csv" && <Scrollbars autoHeight autoHeightMin={this.state.sheight - 180}
                              thumbMinSize={30} >
                              {(this.state.fileType === "jpeg" || this.state.fileType === "jpg" ||
                                this.state.fileType === "png") &&
                                <img src={this.state.myContent} alt="No Image" />
                              }
                              {(this.state.fileType === "py" || this.state.fileType === "log") &&
                                <p className="contentpara">
                                  {this.state.myContent.split("\n").map((i, key) => {
                                    return <div>{i}</div>;
                                  })}
                                </p>
                              }
                              {this.state.fileType === "pdf" &&
                                <div>
                                  {this.state.myContent !== "" &&
                                    <PdfViewer myContent={this.state.myContent}></PdfViewer>
                                  }
                                </div>
                              }
                              {(this.state.fileType === "xlsx" || this.state.fileType === "xls") &&
                                <div>
                                  <Tabs onChange={(tabId) => {
                                    this.setState({
                                      activeTab: tabId,
                                    })
                                  }}>
                                    <div className="proj-search">
                                      <TabList>
                                        <Row>
                                          <div className="col-12 proj-tabs">
                                            <label><code>Sheets :</code></label>
                                            {this.state.sheetName.map((item, index) => (
                                              <Tab tabFor={item} className="adddatatab" onClick={e => this.getTabData(item)}>{item}</Tab>
                                            ))
                                            }
                                          </div>
                                        </Row>
                                      </TabList>
                                    </div>
                                    <CardBody>
                                      <Scrollbars  autoHeight autoHeightMin={this.state.sheight - 200}>
                                        <TabPanel tabId={this.state.activeExcel}>
                                          <HotTable
                                            root="hot"
                                            ref={this.hotTableComponent}
                                            data={this.state.hotSettings}
                                            colHeaders={true}
                                            readOnly={this.state.readonlyTable}
                                            rowHeaders={true}
                                            comments={true}
                                            search={true}
                                            dropdownMenu={this.state.contextMenuTable}
                                            multiColumnSorting={true}
                                            filters={true}
                                            settings={this.hotformula}
                                            manualRowMove={true}
                                            contextMenu={this.state.contextMenuTable}
                                            licenseKey={HandsonTableKey}
                                            stretchH="all"
                                            renderer={this.state.rowheader === true ? this.renderer : ""}
                                          />
                                        </TabPanel>
                                      </Scrollbars>
                                    </CardBody>
                                  </Tabs>


                                </div>
                              }
                              {this.state.fileType === "ipynb" &&
                                <div id="notebookDiv">
                                  {this.state.myContent !== "" ? this.state.myContent.map((item, index) => (
                                    <div key={index} id={item.metadata.contentid}>
                                      {/* if cell type is mark down */}
                                      {item.cell_type === "markdown" &&
                                        <Row ref={(node) => item.metadata.contentid = node} >
                                          <Col>
                                            <div className="displaytxt" >
                                              <Row className="align-items-center">
                                                <div className="col-12 col-sm-9">
                                                  <MarkDown markdownValue={item.source} id={item.metadata.decisionforce_cell_id} ></MarkDown>
                                                </div>
                                              </Row>
                                            </div>
                                          </Col>
                                        </Row>
                                      }
                                      {/* if cell type is code decisionforce_cell_id*/}
                                      {item.cell_type === "code" &&
                                        <div>

                                          <div
                                            aria-multiselectable={true}
                                            className="card-collapse"
                                            id="accordion"
                                            role="tablist"
                                          >
                                            <a
                                              aria-expanded={this.state.openMark.includes(
                                                item.metadata.decisionforce_cell_id
                                              )}
                                              href="#pablo"
                                              data-parent="#accordion"
                                              data-toggle="collapse"
                                              onClick={e => {
                                                e.preventDefault();
                                                this.collapsesMarkToggle(item.metadata.decisionforce_cell_id, this.state.openMark.includes(
                                                  item.metadata.decisionforce_cell_id
                                                ));
                                              }}
                                            >
                                              <Row className="align-items-center">
                                                <div className="col-12 col-sm-10">
                                                  <div className="hrdiv">
                                                    <span className="hrtext">
                                                      Code
                                                    </span>
                                                  </div>
                                                </div>
                                                <div className="col-12 col-sm-2 text-right">
                                                  <span className="codetxt" >
                                                    <button className="btn-icon btn-round btn btn-linkedin defaultcursor" >{item.metadata.codeindex}</button>
                                                  </span> <i className={this.state.openMark.includes(item.metadata.decisionforce_cell_id) === false ? "fas fa-plus-circle" : "fas fa-minus-circle"}></i>
                                                </div>
                                              </Row>
                                            </a>
                                            <Collapse
                                              role="tabpanel"
                                              isOpen={this.state.openMark.includes(
                                                item.metadata.decisionforce_cell_id
                                              )}
                                            >
                                              <CardBody>
                                                <Row>
                                                  <Col xs="12" className="code-highlight-top">
                                                    <div>
                                                      <CodeHighlight
                                                        codeValue={item.source}
                                                        data={item}
                                                        output={item.outputs}
                                                        language={this.state.lang}
                                                        flagId={this.state.codeFlag}
                                                        index={index}
                                                        _getNewCode={this._getNewCode} />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </CardBody>
                                            </Collapse>
                                          </div>
                                          <Row className="outputmargin">
                                            <div className="displaytxt col-12" >
                                              {item.outputs.length > 0 && <div className="outputBorder">
                                              </div>
                                              }
                                              {item.outputs.length > 0 && <div className="displaytxt col-12">
                                                <span title="Click To Copy" className="clickcopy float-right p-2 rounded">
                                                  <span className={this.state.copiedindex === index ? this.state.getCopyText ? "copiedBack" : "" : ""}>{this.state.copiedindex === index ? this.state.getCopyText ? "Copied" : "" : ""}</span>
                                                  <i className="fas fa-copy" onClick={e => this.handlerangeClick(e, renderOutput(item.outputs), index)}></i></span>
                                                <pre><code><div id={"outputContents" + index} dangerouslySetInnerHTML={{ __html: renderOutput(item.outputs) }}></div></code></pre>
                                              </div>
                                              }
                                            </div>
                                          </Row>

                                        </div>
                                      }
                                    </div>)) : <div key={uuidv4()}></div>
                                  }
                                </div>
                              }

                              {(this.state.fileType === "others") &&
                                <p className="othercontentpara">
                                  {this.state.myContent}
                                </p>
                              }
                            </Scrollbars>}

                            {this.state.fileType === "csv" &&
                              <div>
                                <Scrollbars autoHeight autoHeightMin={this.state.sheight - 200}
                                  thumbMinSize={30} style={{ position: "inherit" }}
                                  renderTrackHorizontal={props => <div {...props} className="track-horizontal" />}
                                  renderTrackVertical={props => <div {...props} className="track-vertical" />}>
                                  <br></br>
                                  <Row>
                                    <Col xs="3" className="font13">
                                      <b>{(this.state.currentVersion !== "" && this.state.currentVersion !== null && this.state.currentVersion !== undefined) ? <code><b>Version : </b></code> : ""}
                                        {(this.state.currentVersion !== "" && this.state.currentVersion !== null && this.state.currentVersion !== undefined && this.state.currentVersion !== "original") ? moment.utc(this.state.currentVersion).local().format('MMM DD YYYY', 'h:mm:ss a') : ""}
                                        {(this.state.currentVersion !== "" && this.state.currentVersion !== null && this.state.currentVersion !== undefined && this.state.currentVersion !== "original") ? moment.utc(this.state.currentVersion).local().format('h:mm A') : ""}
                                        {this.state.currentVersion === "original" ? "Original" : ""} </b>

                                    </Col>
                                    <Col xs="8" className="font13">
                                      <b>{this.state.currentComments !== "" ? <code><b>Comments : </b></code> : ""}{this.state.currentComments}  </b>
                                    </Col>
                                  </Row>
                                  <span className='errorCsv mt-2'>{this.state.errorFile}</span>
                                  <Row>
                                    <Col className="text-center">
                                      <b>{this.state.NoDataText}</b>
                                    </Col>
                                  </Row>
                                  {this.state.NoData === false &&
                                    <HotTable
                                      root="hot"
                                      className="hot-table"
                                      ref={this.hotTableComponent}
                                      data={this.state.hotSettings}
                                      colHeaders={true}
                                      readOnly={this.state.readonlyTable}
                                      rowHeaders={true}
                                      comments={true}
                                      search={true}
                                      dropdownMenu={this.state.contextMenuTable}
                                      multiColumnSorting={true}
                                      filters={true}
                                      settings={this.hotformula}
                                      afterSetCellMeta={this.setCellMetaData}
                                      manualRowMove={true}
                                      contextMenu={this.state.contextMenuTable}
                                      licenseKey={HandsonTableKey}
                                      stretchH="all"
                                      renderer={this.state.rowheader === true ? this.renderer : ""}
                                    />
                                  }
                                  <Col xs={12}>
                                    <Row className="floatright">
                                      <Button className="btn-navigate" onClick={this.handlePrevPageClick}>Prev</Button>
                                      <Button className="btn-navigate" disabled={this.state.btnNextState} onClick={this.handleNextPageClick}>Next</Button>
                                    </Row>
                                  </Col>
                                </Scrollbars>
                              </div>
                            }
                          </Col>
                          {(this.state.showVersion === true && this.state.fileType === "csv") &&
                            <Col xs={12} sm={this.state.showVersion === true ? 2 : 12} className="csvborder">
                              <ul className="list-group">
                                <li className="list-group-item">
                                  <Row>
                                    <Col xs={12}>
                                      <i className="fa fa-angle-double-right mr-2 text-right pointerclass" onClick={e => { this.setState({ showVersion: !this.state.showVersion }); this.callVersion(this.state.showVersion, this.state.fileName, this.state.storageId, this.state.rootFolder); }}></i>
                                      <span className="pl-1"><b>Version History</b></span>
                                    </Col>
                                  </Row>
                                </li>
                              </ul>
                              <ul className="list-group">
                                <li className={this.state.showOriginal === true ? "list-group-item active" : "list-group-item"}>
                                  <span className="storage-file" onClick={e => { this.renderFileView(); this.showOriginal(true) }}><b><i className="fas fa-caret-right"></i> &nbsp;View Latest File</b></span>
                                </li>
                              </ul>
                              <Versioning update={this.updateState} versionValue={this.state.versionValue} listversion={this.state.listversion} fileName={this.state.fileName} storageId={this.state.storageId} rootFolder={this.state.rootFolder} selectedVersionName={this.state.selectedVersionName} parentCallback={this.callVersion} ></Versioning>
                            </Col>
                          }




                        </Row>
                        {/* </Scrollbars>   */}

                        <Modal
                          centered
                          className="rename-modal"
                          isOpen={this.state.showSaveModal}
                          toggle={this.toggleSaveModal}
                          backdrop="static"
                          returnFocusAfterClose={false}>
                          <ModalHeader toggle={this.toggleSaveModal}>Comments to Save</ModalHeader>
                          <ModalBody>
                            <Input
                              type="textarea"
                              placeholder="Comments to Save"
                              name="commentstosave"
                              className="inputRename"
                              maxLength="150"
                              value={this.state.savecomments}
                              onChange={this.saveCommentschange}
                            />
                            <Row>
                              <Col sm={12} lg={12} xl={12}>
                                <span className="notepopHint">Note: </span><span className="notetxt"> <code>Comments should be more than 4 letters and less than 100 letters</code></span>
                              </Col>
                            </Row>
                            <Row>
                              {this.state.savefrom === "Save" && <Col sm={12} lg={12} xl={12}>
                                {this.state.showSavebutton === true &&
                                  <Button
                                    size="sm"
                                    color="primary"
                                    className="storage-folder-btn renameBtn"
                                    onClick={e => this.saveHandsontable(this.state.fileName)}
                                  >
                                    Save
                                  </Button>
                                }
                              </Col>}
                              {this.state.savefrom === "Saveas" && <Col sm={12} lg={12} xl={12}>
                                {this.state.showSavebutton === true &&
                                  <Button
                                    size="sm"
                                    color="primary"
                                    className="storage-folder-btn renameBtn"
                                    onClick={e => this.createFileInit(this.state.fileToBeCreate, this.state.currFolder)}>
                                    Save
                                  </Button>
                                }
                              </Col>}
                            </Row>

                          </ModalBody>
                        </Modal>

                        <Modal
                          centered
                          className="upload-modal"
                          isOpen={this.state.showSaveasModal}
                          toggle={this.toggleSaveas}
                          backdrop="static"
                          returnFocusAfterClose={false}
                        >
                          <ModalHeader toggle={this.toggleSaveas}>File Manager</ModalHeader>
                          <ModalBody>
                            <hr className="my-1" />
                            <div className="logo-and-nav-wrap">
                              <div className="site-nav-wrap">
                                <div className="navss">
                                  {this.state.storageNavigations}
                                </div>
                              </div>
                            </div>
                            <Scrollbars autoHeight autoHeightMin={this.state.sheight - 300} thumbMinSize={30} onScroll={this.handleScroll}>
                              <hr className="my-1" />
                              <AddStorageItems
                                folders={this.state.folders}
                                files={this.state.files}
                                fetchStorageItems={this.fetchStorageItems}
                                loadmoreFlag={this.state.loadmoreFlag}
                                showFilesModal={this.state.showFilesModal}
                                nextPageToken={this.state.nextPageToken}
                                previewFile={this.previewFile}
                                loadflagStorage={this.state.loadflagStorage}
                                currFolder={this.state.currFolder}
                                pasteFolder={this.pasteFolder}
                                selectMoveFile={this.selectMoveFile}
                                selectCopyFile={this.selectCopyFile}
                                renameFile={this.renameFile}
                                toggleShowFiles={this.toggleShowFiles}
                                refreshstorage={this.refreshstorage}
                                fetchProgress={this.fetchProgress}
                                sourceStorageId={this.state.sourceStorageId}
                                sourceRootFolder={this.state.sourceRootFolder}
                                configArray={this.state.configArray}
                                progressmsg={this.state.progressmsg}
                              />
                            </Scrollbars>
                            <div className="saveastxtbox" >
                              <InputGroup>
                                <Input
                                  placeholder="Untitled"
                                  name="fileToBeCreate"
                                  id="fileToBlank"
                                  className="inputBorderLine"
                                  value={this.state.fileToBeCreate}
                                  onChange={this.handleInputChangeFile} />

                                <InputGroupAddon addonType="append" className="AliginMargin">
                                  <Button
                                    color="primary"
                                    className="storage-folder-btn"
                                    onClick={e => this.toggleSaveModal('Saveas')}>
                                    Save
                                  </Button>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </ModalBody>
                        </Modal>


                      </div>
                    </Scrollbars>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default StorageView;